// Generated by scripts/build-trade-account.mjs. Edit the source files, then rebuild.

// Source: trade-account-tlds.js
// Bundled IANA root-zone TLD snapshot; no runtime network request.
// Source: https://data.iana.org/TLD/tlds-alpha-by-domain.txt
// Version 2026102500, Last Updated Sun Oct 25 07:07:02 2026 UTC
// Source SHA256: ca3fa13460e8f94ac049ece2fd272a1b17c156e37b55d467dd7b5037e390fe25
const emailTopLevelDomains = new Set(
  'aaa aarp abb abbott abbvie abc able abogado abudhabi ac academy accenture accountant accountants aco actor ad ads adult ae aeg aero aetna af afl africa ag agakhan agency ai aig airbus airforce airtel akdn al alibaba alipay allfinanz allstate ally alsace alstom am amazon americanexpress americanfamily amex amfam amica amsterdam analytics android anquan anz ao aol apartments app apple aq aquarelle ar arab aramco archi army arpa art arte as asda asia associates at athleta attorney au auction audi audible audio auspost author auto autos aw aws ax axa az azure ba baby baidu banamex band bank bar barcelona barclaycard barclays barefoot bargains baseball basketball bauhaus bayern bb bbc bbt bbva bcg bcn bd be beats beauty beer berlin best bestbuy bet bf bg bh bharti bi bible bid bike bing bingo bio biz bj black blackfriday blockbuster blog bloomberg blue bm bms bmw bn bnpparibas bo boats boehringer bofa bom bond boo book booking bosch bostik boston bot boutique box br bradesco bridgestone broadway broker brother brussels bs bt build builders business buy buzz bv bw by bz bzh ca cab cafe cal call calvinklein cam camera camp canon capetown capital capitalone car caravan cards care career careers cars casa case cash casino cat catering catholic cba cbn cbre cc cd center ceo cern cf cfa cfd cg ch chanel channel charity chase chat cheap chintai christmas chrome church ci cipriani circle cisco citadel citi citic city ck cl claims cleaning click clinic clinique clothing cloud club clubmed cm cn co coach codes coffee college cologne com commbank community company compare computer comsec condos construction consulting contact contractors cooking cool coop corsica country coupon coupons courses cpa cr credit creditcard creditunion cricket crown crs cruise cruises cu cuisinella cv cw cx cy cymru cyou cz dad dance data date dating datsun day dclk dds de deal dealer deals degree delivery dell deloitte delta democrat dental dentist desi design dev dhl diamonds diet digital direct directory discount discover dish diy dj dk dm dnp do docs doctor dog domains dot download drive dtv dubai dupont durban dvag dvr dz earth eat ec eco edeka edu education ee eg email emerck energy engineer engineering enterprises epson equipment er ericsson erni es esq estate et eu eurovision eus events exchange expert exposed express extraspace fage fail fairwinds faith family fan fans farm farmers fashion fast fedex feedback ferrari ferrero fi fidelity fido film final finance financial fire firestone firmdale fish fishing fit fitness fj fk flickr flights flir florist flowers fly fm fo foo food football ford forex forsale forum foundation fox fr free fresenius frl frogans frontier ftr fujitsu fun fund furniture futbol fyi ga gal gallery gallo gallup game games gap garden gay gb gbiz gd gdn ge gea gent genting george gf gg ggee gh gi gift gifts gives giving gl glass gle global globo gm gmail gmbh gmo gmx gn godaddy gold goldpoint golf goodyear goog google gop got gov gp gq gr grainger graphics gratis green gripe grocery group gs gt gu gucci guge guide guitars guru gw gy hair hamburg hangout haus hbo hdfc hdfcbank health healthcare help helsinki here hermes hiphop hisamitsu hitachi hiv hk hkt hm hn hockey holdings holiday homedepot homegoods homes homesense honda horse hospital host hosting hot hotels hotmail house how hr hsbc ht hu hughes hyatt hyundai ibm icbc ice icu id ie ieee ifm ikano il im imamat imdb immo immobilien in inc industries infiniti info ing ink institute insurance insure int international intuit investments io ipiranga iq ir irish is ismaili ist istanbul it itau itv jaguar java jcb je jeep jetzt jewelry jio jll jm jmp jnj jo jobs joburg jot joy jp jpmorgan jprs juegos kaufen kddi ke kerryhotels kerryproperties kfh kg kh ki kia kids kim kindle kitchen kiwi km kn koeln komatsu kosher kp kpmg kpn kr krd kred kuokgroup kw ky kyoto kz la lacaixa lamborghini lamer land landrover lanxess lasalle lat latino latrobe law lawyer lb lc lds lease leclerc lefrak legal lego lexus lgbt li lidl life lifeinsurance lifestyle lighting like lilly limited limo lincoln link live living lk llc llp loan loans locker locus lol london lotte lotto love lpl lplfinancial lr ls lt ltd ltda lu lundbeck luxe luxury lv ly ma madrid maif maison makeup man management mango map market marketing markets marriott marshalls mattel mba mc mckinsey md me med media meet melbourne meme memorial men menu merck merckmsd mg mh miami microsoft mil mini mint mit mitsubishi mk ml mlb mls mm mma mn mo mobi mobile moda moe moi mom monash money monster mormon mortgage moscow moto motorcycles mov movie mp mq mr ms msd mt mtn mtr mu museum music mv mw mx my mz na nab nagoya name navy nba nc ne nec net netbank netflix network neustar new news next nextdirect nexus nf nfl ng ngo nhk ni nico nike nikon ninja nissan nissay nl no nokia norton now nowruz nowtv np nr nra nrw ntt nu nyc nz obi observer office okinawa olayan olayangroup ollo om omega one ong onl online ooo open oracle orange org organic origins osaka otsuka ott ovh pa page panasonic paris pars partners parts party pay pccw pe pet pf pfizer pg ph pharmacy phd philips phone photo photography photos physio pics pictet pictures pid pin ping pink pioneer pizza pk pl place play playstation plumbing plus pm pn pnc pohl poker politie porn post pr praxi press prime pro prod productions prof progressive promo properties property protection pru prudential ps pt pub pw pwc py qa qpon quebec quest racing radio re read realestate realtor realty recipes red redumbrella rehab reise reisen reit reliance ren rent rentals repair report republican rest restaurant review reviews rexroth rich richardli ricoh ril rio rip ro rocks rodeo rogers room rs rsvp ru rugby ruhr run rw rwe ryukyu sa saarland safe safety sakura sale salon samsclub samsung sandvik sandvikcoromant sanofi sap sarl sas save saxo sb sbi sbs sc scb schaeffler schmidt scholarships school schule schwarz science scot sd se search seat secure security seek select sener services seven sew sex sexy sfr sg sh shangrila sharp shell shia shiksha shoes shop shopping shouji show si silk sina singles site sj sk ski skin sky skype sl sling sm smart smile sn sncf so soccer social softbank software sohu solar solutions song sony soy spa space sport spot sr srl ss st stada staples star statebank statefarm stc stcgroup stockholm storage store stream studio study style su sucks supplies supply support surf surgery suzuki sv swatch swiss sx sy sydney systems sz tab taipei talk taobao target tatamotors tatar tattoo tax taxi tc tci td tdk team tech technology tel temasek tennis teva tf tg th thd theater theatre tiaa tickets tienda tips tires tirol tj tjmaxx tjx tk tkmaxx tl tm tmall tn to today tokyo tools top toray toshiba total tours town toyota toys tr trade trading training travel travelers travelersinsurance trust trv tt tube tui tunes tushu tv tvs tw tz ua ubank ubs ug uk unicom university uno uol ups us uy uz va vacations vana vanguard vc ve vegas ventures verisign versicherung vet vg vi viajes video vig viking villas vin vip virgin visa vision viva vivo vlaanderen vn vodka volvo vote voting voto voyage vu wales walmart walter wang wanggou watch watches weather weatherchannel web webcam weber website wed wedding weibo weir wf whoswho wien wiki williamhill win windows wine winners wme woodside work works world wow ws wtc wtf xbox xerox xihuan xin xn--11b4c3d xn--1ck2e1b xn--1qqw23a xn--2scrj9c xn--30rr7y xn--3bst00m xn--3ds443g xn--3e0b707e xn--3hcrj9c xn--3pxu8k xn--42c2d9a xn--45br5cyl xn--45brj9c xn--45q11c xn--4dbrk0ce xn--4gbrim xn--54b7fta0cc xn--55qw42g xn--55qx5d xn--5su34j936bgsg xn--5tzm5g xn--6frz82g xn--6qq986b3xl xn--80adxhks xn--80ao21a xn--80aqecdr1a xn--80asehdb xn--80aswg xn--8y0a063a xn--90a3ac xn--90ae xn--90ais xn--9dbq2a xn--9et52u xn--9krt00a xn--b4w605ferd xn--bck1b9a5dre4c xn--c1avg xn--c2br7g xn--cck2b3b xn--cckwcxetd xn--cg4bki xn--clchc0ea0b2g2a9gcd xn--czr694b xn--czrs0t xn--czru2d xn--d1acj3b xn--d1alf xn--e1a4c xn--eckvdtc9d xn--efvy88h xn--fct429k xn--fhbei xn--fiq228c5hs xn--fiq64b xn--fiqs8s xn--fiqz9s xn--fjq720a xn--flw351e xn--fpcrj9c3d xn--fzc2c9e2c xn--fzys8d69uvgm xn--g2xx48c xn--gckr3f0f xn--gecrj9c xn--gk3at1e xn--h2breg3eve xn--h2brj9c xn--h2brj9c8c xn--hxt814e xn--i1b6b1a6a2e xn--imr513n xn--io0a7i xn--j1aef xn--j1amh xn--j6w193g xn--jlq480n2rg xn--jvr189m xn--kcrx77d1x4a xn--kprw13d xn--kpry57d xn--kput3i xn--l1acc xn--lgbbat1ad8j xn--mgb9awbf xn--mgba3a3ejt xn--mgba3a4f16a xn--mgba7c0bbn0a xn--mgbaam7a8h xn--mgbab2bd xn--mgbah1a3hjkrd xn--mgbai9azgqp6j xn--mgbayh7gpa xn--mgbbh1a xn--mgbbh1a71e xn--mgbc0a9azcg xn--mgbca7dzdo xn--mgbcpq6gpa1a xn--mgberp4a5d4ar xn--mgbgu82a xn--mgbi4ecexp xn--mgbpl2fh xn--mgbt3dhd xn--mgbtx2b xn--mgbx4cd0ab xn--mix891f xn--mk1bu44c xn--mxtq1m xn--ngbc5azd xn--ngbe9e0a xn--ngbrx xn--node xn--nqv7f xn--nqv7fs00ema xn--nyqy26a xn--o3cw4h xn--ogbpf8fl xn--otu796d xn--p1acf xn--p1ai xn--pgbs0dh xn--pssy2u xn--q7ce6a xn--q9jyb4c xn--qcka1pmc xn--qxa6a xn--qxam xn--rhqv96g xn--rovu88b xn--rvc1e0am3e xn--s9brj9c xn--ses554g xn--t60b56a xn--tckwe xn--tiq49xqyj xn--unup4y xn--vermgensberater-ctb xn--vermgensberatung-pwb xn--vhquv xn--vuq861b xn--w4r85el8fhu5dnra xn--w4rs40l xn--wgbh1c xn--wgbl6a xn--xhq521b xn--xkc2al3hye2a xn--xkc2dl3a5ee0h xn--y9a3aq xn--yfro4i67o xn--ygbi2ammx xn--zfr164b xxx xyz yachts yahoo yamaxun yandex ye yodobashi yoga yokohama you youtube yt yun za zappos zara zero zip zm zone zuerich zw'.split(' ')
);


// Source: trade-account-schema.js
// Trade-account-only contract. Keep the service copy identical.
const termsVersion = '2026-09-28-v3';
const steps = [
  {
    "title": "Introduction and privacy",
    "intro": [
      "Thank you for your interest in opening an account with Artisan Chemist.",
      "Accounts are available to approved business customers, including medical practices, veterinary practices, pharmacies, healthcare providers and other eligible organisations.",
      "The application should take approximately 5–10 minutes to complete. Before you begin, please have the following details available:",
      [
        "legal entity name",
        "ABN/ACN (where applicable)",
        "business and billing details",
        "primary and account contacts",
        "contact details of those authorised to place orders on the account"
      ],
      "All applications are subject to review and approval, and we may request additional information where reasonably required to assess or administer the account."
    ],
    "fields": [
      {
        "type": "document",
        "document": "privacy",
        "label": "Privacy and Account Assessment"
      },
      {
        "name": "privacyAccepted",
        "label": "I acknowledge that I have read and understood the Privacy and Account Assessment information above and Artisan Chemist's Privacy Policy.",
        "type": "checkbox",
        "required": true
      }
    ]
  },
  {
    "title": "Terms, authority and applicant details",
    "fields": [
      {
        "type": "document",
        "document": "terms",
        "label": "Trade Account Terms and Conditions"
      },
      {
        "name": "termsAccepted",
        "label": "I have read and agree to the Trade Account Terms and Conditions.",
        "type": "checkbox",
        "required": true
      },
      {
        "name": "authorityAccepted",
        "label": "I confirm that I am authorised to submit this application and apply for a Trade Account on behalf of the organisation named in this application.",
        "type": "checkbox",
        "required": true
      },
      {
        "name": "applicantFirstName",
        "label": "First name",
        "type": "text",
        "required": true
      },
      {
        "name": "applicantLastName",
        "label": "Last name",
        "type": "text",
        "required": true
      },
      {
        "name": "applicantRole",
        "label": "Position / role",
        "type": "text",
        "required": true
      },
      {
        "name": "applicantEmail",
        "label": "Email address",
        "type": "email",
        "required": true
      },
      {
        "name": "applicantPhone",
        "label": "Phone number",
        "type": "tel",
        "required": true
      }
    ]
  },
  {
    "title": "Business details",
    "fields": [
      {
        "name": "legalName",
        "label": "Legal entity name",
        "type": "text",
        "required": true,
        "help": "Enter the full legal name of the entity that will be responsible for the Trade Account."
      },
      {
        "name": "sameTradingName",
        "label": "Is your trading name the same as your legal entity name?",
        "type": "select",
        "options": [
          "Yes",
          "No"
        ],
        "required": true
      },
      {
        "name": "tradingName",
        "label": "Trading name",
        "type": "text",
        "required": true,
        "when": {
          "sameTradingName": "No"
        }
      },
      {
        "name": "abn",
        "label": "ABN",
        "type": "text",
        "required": true,
        "inputmode": "numeric",
        "help": "Enter the 11-digit Australian Business Number."
      },
      {
        "name": "structure",
        "label": "Business structure",
        "type": "select",
        "options": [
          "Company",
          "Sole trader",
          "Partnership",
          "Trust",
          "Incorporated association",
          "Other"
        ],
        "required": true
      },
      {
        "name": "structureOther",
        "label": "Please specify business structure",
        "type": "text",
        "required": true,
        "when": {
          "structure": "Other"
        }
      },
      {
        "name": "acn",
        "label": "ACN (if applicable)",
        "type": "text",
        "inputmode": "numeric",
        "help": "9 digits, if applicable."
      },
      {
        "name": "businessTypes",
        "label": "Business type",
        "type": "checks",
        "singleSelect": true,
        "required": true,
        "options": [
          "Medical practice / clinic",
          "Veterinary practice / clinic",
          "Cosmetic / aesthetic clinic",
          "Pharmacy",
          "Allied health",
          "Hospital",
          "Research / laboratory",
          "Other business"
        ]
      },
      {
        "name": "businessTypeOther",
        "label": "Please specify business type",
        "type": "text",
        "required": true,
        "when": {
          "businessTypes": "Other business"
        }
      },
      {
        "name": "website",
        "label": "Business website",
        "type": "url"
      },
      {
        "name": "yearStarted",
        "label": "Year business commenced operating",
        "type": "number",
        "min": 1800
      }
    ]
  },
  {
    "title": "Business addresses",
    "fields": [
      {
        "type": "group",
        "label": "Business address",
        "address": "business",
        "fields": [
          {
            "name": "businessStreet",
            "label": "Street address",
            "type": "text",
            "required": true,
            "autocomplete": "street-address"
          },
          {
            "name": "businessSuburb",
            "label": "Suburb",
            "type": "text",
            "required": true
          },
          {
            "name": "businessState",
            "label": "State / Territory",
            "type": "select",
            "options": [
              "ACT",
              "NSW",
              "NT",
              "QLD",
              "SA",
              "TAS",
              "VIC",
              "WA"
            ],
            "required": true
          },
          {
            "name": "businessPostcode",
            "label": "Postcode",
            "type": "text",
            "required": true,
            "pattern": "[0-9]{4}",
            "inputmode": "numeric",
            "maxlength": 4
          }
        ]
      },
      {
        "name": "billingSame",
        "label": "Is the billing address the same as the business address?",
        "type": "select",
        "options": [
          "Yes",
          "No"
        ],
        "required": true
      },
      {
        "type": "group",
        "label": "Billing address",
        "when": {
          "billingSame": "No"
        },
        "address": "billing",
        "fields": [
          {
            "name": "billingStreet",
            "label": "Street address",
            "type": "text",
            "required": true,
            "autocomplete": "street-address"
          },
          {
            "name": "billingSuburb",
            "label": "Suburb",
            "type": "text",
            "required": true
          },
          {
            "name": "billingState",
            "label": "State / Territory",
            "type": "select",
            "options": [
              "ACT",
              "NSW",
              "NT",
              "QLD",
              "SA",
              "TAS",
              "VIC",
              "WA"
            ],
            "required": true
          },
          {
            "name": "billingPostcode",
            "label": "Postcode",
            "type": "text",
            "required": true,
            "pattern": "[0-9]{4}",
            "inputmode": "numeric",
            "maxlength": 4
          }
        ]
      },
      {
        "name": "deliverySame",
        "label": "Is the primary delivery address the same as the business address?",
        "type": "select",
        "options": [
          "Yes",
          "No"
        ],
        "required": true
      },
      {
        "type": "group",
        "label": "Delivery address",
        "when": {
          "deliverySame": "No"
        },
        "address": "delivery",
        "fields": [
          {
            "name": "deliveryStreet",
            "label": "Address, PO Box, Parcel Locker number",
            "type": "text",
            "required": true,
            "autocomplete": "street-address"
          },
          {
            "name": "deliverySuburb",
            "label": "Suburb",
            "type": "text",
            "required": true
          },
          {
            "name": "deliveryState",
            "label": "State / Territory",
            "type": "select",
            "options": [
              "ACT",
              "NSW",
              "NT",
              "QLD",
              "SA",
              "TAS",
              "VIC",
              "WA"
            ],
            "required": true
          },
          {
            "name": "deliveryPostcode",
            "label": "Postcode",
            "type": "text",
            "required": true,
            "pattern": "[0-9]{4}",
            "inputmode": "numeric",
            "maxlength": 4
          }
        ]
      }
    ]
  },
  {
    "title": "Primary and accounts contacts",
    "fields": [
      {
        "type": "group",
        "label": "Primary contact",
        "fields": [
          {
            "name": "primaryFirstName",
            "label": "First name",
            "type": "text",
            "required": true
          },
          {
            "name": "primaryLastName",
            "label": "Last name",
            "type": "text",
            "required": true
          },
          {
            "name": "primaryRole",
            "label": "Position / role",
            "type": "text",
            "required": true
          },
          {
            "name": "primaryEmail",
            "label": "Email address",
            "type": "email",
            "required": true
          },
          {
            "name": "primaryPhone",
            "label": "Phone number",
            "type": "tel",
            "required": true
          }
        ]
      },
      {
        "name": "accountsSame",
        "label": "Is the accounts contact the same as the primary contact?",
        "type": "select",
        "options": [
          "Yes",
          "No"
        ],
        "required": true
      },
      {
        "type": "group",
        "label": "Accounts contact",
        "when": {
          "accountsSame": "No"
        },
        "fields": [
          {
            "name": "accountsFirstName",
            "label": "First name",
            "type": "text",
            "required": true
          },
          {
            "name": "accountsLastName",
            "label": "Last name",
            "type": "text",
            "required": true
          },
          {
            "name": "accountsRole",
            "label": "Position / role",
            "type": "text",
            "required": false
          },
          {
            "name": "accountsEmail",
            "label": "Email address",
            "type": "email",
            "required": true
          },
          {
            "name": "accountsPhone",
            "label": "Phone number",
            "type": "tel",
            "required": false
          }
        ]
      },
      {
        "name": "invoiceEmail",
        "label": "Email addresses for invoices (sent upon order confirmation)",
        "type": "textarea",
        "emailList": true,
        "required": true,
        "help": "You can enter multiple email addresses, separated by commas or one per line. For example: accounts@yourclinic.com.au, manager@yourclinic.com.au."
      },
      {
        "name": "statementEmail",
        "label": "Email addresses for statements",
        "type": "textarea",
        "emailList": true,
        "required": true,
        "help": "You can enter multiple email addresses, separated by commas or one per line. For example: accounts@yourclinic.com.au, manager@yourclinic.com.au."
      }
    ]
  },
  {
    "title": "Authorised account users",
    "intro": [
      "Please list the email addresses your clinic will use to place orders or make account enquiries. Orders must come from a listed email address to be charged to your account. Contact us whenever you need to add or remove an address."
    ],
    "fields": [
      {
        "name": "authorisedEmails",
        "label": "Please list email addresses you will use to place orders:",
        "type": "textarea",
        "required": true,
        "help": "e.g. info@yourclinic.com.au, anotherclinic.com.au"
      }
    ]
  },
  {
    "title": "Review and submit",
    "review": true,
    "intro": [
      "Please review your answers before submitting your application.",
      "Please confirm that the information is complete and accurate to the best of your knowledge."
    ],
    "fields": [
      {
        "name": "accuracyAccepted",
        "label": "I confirm that the information provided in this application is complete and accurate to the best of my knowledge.",
        "type": "checkbox",
        "required": true
      }
    ]
  }
];


// Source: trade-account-validation.js

// Basic format checks only: these do not prove a mailbox or phone is reachable.
function validEmail(value) {
  if (typeof value !== 'string') return false;
  const email = value.trim();
  if (email.length > 254) return false;
  const parts = email.split('@');
  if (parts.length !== 2) return false;
  const [local, domain] = parts;
  if (!local || local.length > 64 || local.startsWith('.') || local.endsWith('.') || local.includes('..')) return false;
  if (!/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+$/.test(local)) return false;
  const labels = domain.split('.');
  return labels.length >= 2 && labels.every(label =>
    label.length <= 63 && /^[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(label));
}
function validPhone(value) {
  if (typeof value !== 'string') return false;
  const phone = value.trim();
  // Same formatting characters as prescriber registration, plus a digit-count guard.
  if (!/^\+?[0-9 ()-]{8,20}$/.test(phone) || phone.length > 20) return false;
  const digits = phone.replace(/\D/g, '');
  return digits.length >= 8 && digits.length <= 15;
}
function listEntries(value) {
  return typeof value === 'string' ? value.split(/[\n,;]+/).map(entry => entry.trim()).filter(Boolean) : [];
}
function validAuthorisedEntry(entry) {
  if (entry.includes('@')) return validEmail(entry);
  return entry.length <= 253 && /^([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i.test(entry);
}
function normaliseAuthorisedEmails(value) {
  if (typeof value !== 'string') return value;
  const entries = value.split(/[\s,;]+/).filter(Boolean);
  // Never guess at malformed addresses or discard unrecognised words.
  return entries.length && entries.every(validAuthorisedEntry) ? entries.join(', ') : value;
}
function normaliseEmailList(value) {
  if (typeof value !== 'string') return value;
  const entries = value.split(/[\s,;]+/).filter(Boolean);
  return entries.length && entries.every(validEmail) ? entries.join(', ') : value;
}
function normaliseWebsite(value) {
  const website = value.trim();
  return website && !/^[a-z][a-z0-9+.-]*:/i.test(website) ? 'https://' + website : website;
}

function isVisible(field, values) {
  return !field.when || Object.entries(field.when).every(([key, expected]) => {
    const actual = values[key];
    return (Array.isArray(expected) ? expected : [expected]).some(value =>
      Array.isArray(actual) ? actual.includes(value) : actual === value);
  });
}
function cleanValues(input, fields = steps.flatMap(s => s.fields)) {
  const result = {};
  for (const field of fields) {
    if (!isVisible(field, input)) continue;
    if (field.type === 'group') Object.assign(result, cleanValues(input, field.fields));
    else if (field.type === 'repeat') {
      result[field.name] = (Array.isArray(input[field.name]) ? input[field.name] : [])
        .slice(0, field.maxRows).map(row => cleanValues(row && typeof row === 'object' ? row : {}, field.fields));
    } else if (field.name) {
      const value = input[field.name];
      result[field.name] = field.type === 'checkbox' ? value === true
        : field.type === 'checks' ? (Array.isArray(value) ? [...new Set(value.filter(v => typeof v === 'string'))] : [])
        : typeof value === 'string' ? (field.emailList ? normaliseEmailList(value).trim() : field.type === 'url' ? normaliseWebsite(value) : value.trim()) : '';
    }
  }
  return result;
}
function validate(values, fields = steps.flatMap(s => s.fields), prefix = '') {
  if (!values || typeof values !== 'object' || Array.isArray(values)) return [{ name: prefix, message: 'Invalid details.' }];
  const errors = [];
  const fail = (name, message) => errors.push({ name: prefix + name, message });
  for (const f of fields) {
    if (!isVisible(f, values)) continue;
    if (f.type === 'group') { errors.push(...validate(values, f.fields, prefix)); continue; }
    if (!f.name) continue;
    const value = values[f.name];
    if (f.type === 'repeat') {
      const rows = Array.isArray(value) ? value : [];
      if (rows.length < f.minRows || rows.length > f.maxRows) fail(f.name, 'Check the number of ' + f.label.toLowerCase() + ' entries.');
      rows.forEach((row, i) => errors.push(...validate(row, f.fields, prefix + f.name + '.' + i + '.')));
      continue;
    }
    const empty = value === undefined || value === '' || value === false || (Array.isArray(value) && !value.length);
    if (empty) { if (f.required) fail(f.name, f.type === 'checkbox' ? 'Please check acknowledgement' : f.label + ' is required.'); continue; }
    if (f.type === 'checkbox') { if (value !== true) fail(f.name, 'Please check acknowledgement'); continue; }
    if (f.type === 'checks') {
      if (f.singleSelect && (!Array.isArray(value) || value.length !== 1)) { fail(f.name, 'Choose one business type.'); continue; }
      if (!Array.isArray(value) || value.some(v => !f.options.includes(v))) fail(f.name, 'Choose valid options for ' + f.label + '.');
      continue;
    }
    if (typeof value !== 'string' || value.length > (f.type === 'textarea' ? 4000 : 300) || /[\u0000-\u0008\u000b\u000c\u000e-\u001f]/.test(value)) {
      fail(f.name, 'Please shorten or correct ' + f.label + '.'); continue;
    }
    if (f.options && !f.options.includes(value)) fail(f.name, 'Choose an option for ' + f.label + '.');
    if (f.emailList) {
      const entries = listEntries(normaliseEmailList(value));
      if (!entries.length || entries.some(entry => !validEmail(entry))) fail(f.name, 'Enter valid email addresses separated by commas or one per line, such as accounts@example.com, manager@example.com.');
    }
    if (f.type === 'email' && !validEmail(value)) fail(f.name, 'Enter a valid email address, such as name@example.com.');
    if (f.name === 'applicantEmail' && validEmail(value) && !emailTopLevelDomains.has(value.trim().split('.').at(-1).toLowerCase())) fail(f.name, 'Enter a valid email address, such as name@example.com.');
    if (f.type === 'tel' && !validPhone(value)) fail(f.name, 'Enter a valid phone number with 8–15 digits. Spaces, brackets, hyphens and a leading + are allowed.');
    if (f.type === 'url') {
      try {
        const website = new URL(normaliseWebsite(value));
        if (!['https:', 'http:'].includes(website.protocol) || !website.hostname.includes('.') || website.username || website.password || /\s/.test(value.trim())) throw new Error();
      }
      catch { fail(f.name, 'Enter a valid website, such as example.com or www.example.com.'); }
    }
    if (f.pattern && !new RegExp('^(?:' + f.pattern + ')$').test(value)) fail(f.name, 'Check ' + f.label + '.');
    if (f.type === 'number' && (!Number.isFinite(Number(value)) || Number(value) < (f.min ?? 0) || (f.max && Number(value) > f.max))) fail(f.name, 'Check ' + f.label + '.');
  }
  return errors;
}
function validateApplication(values) {
  if (!values || typeof values !== 'object' || Array.isArray(values)) return [{ name: '', message: 'Invalid application.' }];
  const errors = validate(values);
  const abn = (typeof values.abn === 'string' ? values.abn : '').replace(/\s/g, '');
  if (/^\d{11}$/.test(abn)) {
    const digits = [...abn].map(Number); digits[0] -= 1;
    if (digits.reduce((sum, n, i) => sum + n * [10,1,3,5,7,9,11,13,15,17,19][i], 0) % 89) errors.push({ name: 'abn', message: 'Check the ABN; its check digits do not match.' });
  } else errors.push({ name: 'abn', message: 'Enter an 11-digit ABN.' });
  if (values.acn && (typeof values.acn !== 'string' || !/^\d{9}$/.test(values.acn.replace(/\s/g, '')))) errors.push({ name: 'acn', message: 'Enter a 9-digit ACN.' });
  if (values.yearStarted && (!/^\d{4}$/.test(values.yearStarted) || Number(values.yearStarted) > Number(new Intl.DateTimeFormat('en', { year: 'numeric', timeZone: 'Australia/Brisbane' }).format(new Date())))) errors.push({ name: 'yearStarted', message: 'Enter a valid year.' });
  const authorisedContacts = listEntries(values.authorisedEmails);
  if (!authorisedContacts.length || authorisedContacts.some(entry => !validAuthorisedEntry(entry))) errors.push({ name: 'authorisedEmails', message: 'For individual emails please write "youremail@yourclinic.com.au", to include all emails from your web domain, please write "yourclinic.com.au".' });
  return errors;
}
function displayEntries(fields, values, prefix = '') {
  const rows = [];
  for (const f of fields) {
    if (!isVisible(f, values)) continue;
    if (f.type === 'group') rows.push(...displayEntries(f.fields, values, prefix + f.label + ' — '));
    else if (f.type === 'repeat') (values[f.name] || []).forEach((row, i) => rows.push(...displayEntries(f.fields, row, prefix + f.label + ' ' + (i + 1) + ' — ')));
    else if (f.name) {
      const value = values[f.name];
      rows.push([prefix + f.label, value === true ? 'Confirmed' : Array.isArray(value) ? value.join(', ') : value || 'Not supplied']);
    }
  }
  return rows;
}


// Source: trade-account.js

const el = (tag, text, cls) => {
  const node = document.createElement(tag);
  if (text) node.textContent = text;
  if (cls) node.className = cls;
  return node;
};
let mapsLoader;
function loadAddressLibrary(apiKey) {
  if (window.google?.maps?.places?.Autocomplete) return Promise.resolve();
  if (!apiKey) return Promise.reject(new Error('maps_not_configured'));
  if (!mapsLoader) mapsLoader = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    const timer = setTimeout(() => fail(), 15000);
    const fail = () => { clearTimeout(timer); script.remove(); mapsLoader = undefined; reject(new Error('maps_unavailable')); };
    window.DawnTradeAddressAutocomplete = () => {
      clearTimeout(timer);
      if (window.google?.maps?.places?.Autocomplete) resolve(); else fail();
    };
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey)
      + '&libraries=places&callback=DawnTradeAddressAutocomplete';
    script.async = true;
    script.onerror = fail;
    document.head.append(script);
  });
  return mapsLoader;
}
let captchaLoader;
function loadCaptcha(siteKey) {
  if (!siteKey) return Promise.reject(new Error('not_configured'));
  if (!captchaLoader) captchaLoader = new Promise((resolve, reject) => {
    if (window.grecaptcha?.execute) { resolve(); return; }
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(siteKey);
    script.async = true;
    script.onload = resolve;
    script.onerror = () => { captchaLoader = undefined; reject(new Error('captcha_unavailable')); };
    document.head.append(script);
  });
  return captchaLoader;
}
function captcha(siteKey, action) {
  return Promise.race([
    loadCaptcha(siteKey).then(() => new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => window.grecaptcha.execute(siteKey, { action }).then(resolve, reject));
    })),
    new Promise((_, reject) => setTimeout(() => reject(new Error('captcha_timeout')), 15000))
  ]);
}

function initialise(root) {
  if (root.dataset.initialised) return;
  root.dataset.initialised = 'true';
  const form = root.querySelector('[data-trade-form]');
  const host = root.querySelector('[data-trade-steps]');
  const status = root.querySelector('[data-trade-status]');
  const back = root.querySelector('[data-trade-back]');
  const next = root.querySelector('[data-trade-next]');
  const submit = root.querySelector('[data-trade-submit]');
  const endpoint = root.dataset.endpoint.replace(/\/$/, '');
  const siteKey = root.dataset.recaptchaSiteKey;
  let terms;
  try { terms = JSON.parse(root.dataset.terms); } catch { terms = null; }
  const termsValid = () => typeof terms?.html === 'string' && terms.html.trim().length > 0
    && /^[a-zA-Z0-9._-]{1,80}$/.test(terms.version || '') && /^[a-f0-9]{64}$/.test(terms.hash || '');
  let termsContent;
  function renderTerms() {
    termsContent.replaceChildren();
    if (termsValid()) termsContent.innerHTML = terms.html;
    else termsContent.append(el('p', 'The terms are unavailable. Please try again later or contact info@artisanchemist.com.au.'));
  }
  let privacy;
  try { privacy = JSON.parse(root.dataset.privacy); } catch { privacy = null; }
  const privacyValid = () => typeof privacy?.html === 'string' && privacy.html.trim().length > 0
    && /^[a-zA-Z0-9._-]{1,80}$/.test(privacy.version || '') && /^[a-f0-9]{64}$/.test(privacy.hash || '');
  let privacyContent;
  function renderPrivacy() {
    privacyContent.replaceChildren();
    if (privacyValid()) privacyContent.innerHTML = privacy.html;
    else privacyContent.append(el('p', 'The privacy notice is unavailable. Please reload this page or contact info@artisanchemist.com.au.'));
  }
  // Show Google's standard side badge on entry; generate fresh tokens only when needed.
  if (siteKey) loadCaptcha(siteKey).catch(() => {});
  const values = {};
  root.querySelector('[data-trade-meter]').max = steps.length;
  const controls = new Map();
  const contactCopies = new Map();
  const contactParts = ['FirstName', 'LastName', 'Role', 'Email', 'Phone'];
  const conditional = [];
  let page = 0, dirty = false, sending = false, finished = false;
  let applicationId = crypto.randomUUID();
  let submittedSnapshot;
  const panels = [];
  const warn = event => { if (dirty && !finished) { event.preventDefault(); event.returnValue = ''; } };
  window.addEventListener('beforeunload', warn);
  const message = (text, error = false) => { status.textContent = text; status.classList.toggle('trade-account__error', error); };

  function sync() {
    contactCopies.forEach((checkbox, target) => {
      if (!checkbox.checked) return;
      contactParts.forEach(part => {
        const name = target + part;
        values[name] = values['applicant' + part] || '';
        const control = controls.get(name);
        if (control) { control.value = values[name]; control.removeAttribute('aria-invalid'); }
      });
    });
    conditional.forEach(({ box, field, scope }) => { box.hidden = !isVisible(field, scope); });
  }
  function changed() {
    dirty = true;
    values.accuracyAccepted = false;
    const agreement = controls.get('accuracyAccepted');
    if (agreement) agreement.checked = false;
    sync();
  }
  function formatEmailLists() {
    for (const name of ['authorisedEmails', 'invoiceEmail', 'statementEmail']) {
      const input = controls.get(name);
      if (!input) continue;
      const formatted = name === 'authorisedEmails' ? normaliseAuthorisedEmails(input.value) : normaliseEmailList(input.value);
      if (formatted === input.value) continue;
      input.value = formatted;
      values[name] = formatted;
      input.removeAttribute('aria-invalid');
      changed();
    }
  }
  function renderFields(fields, scope, parent, prefix = '') {
    const grid = el('div', '', 'trade-account__grid');
    parent.append(grid);
    fields.forEach(field => {
      const key = prefix + (field.name || '');
      const box = el(field.type === 'group' || (field.type === 'checks' && !field.singleSelect) ? 'fieldset' : 'div', '', 'trade-account__field');
      grid.append(box);
      if (field.when) conditional.push({ box, field, scope });
      if (field.type === 'document') {
        box.classList.add('trade-account__wide', 'trade-account__document');
        (field.intro || []).forEach(text => box.append(el('p', text)));
        const content = el('div', '', 'trade-account__scroll');
        if (field.document === 'terms') {
          content.classList.add('trade-account__terms-scroll');
          content.tabIndex = 0; content.setAttribute('role', 'region'); content.setAttribute('aria-label', field.label);
          termsContent = content; renderTerms();
          const link = el('a', 'Open the full Terms and Conditions in a new tab');
          link.href = 'https://artisanchemist.com.au/pages/trade-account-terms-conditions';
          link.target = '_blank'; link.rel = 'noopener noreferrer';
          box.append(content, link); return;
        }
        if (field.document === 'privacy') {
          privacyContent = content; renderPrivacy();
          content.tabIndex = 0; content.setAttribute('role', 'region'); content.setAttribute('aria-label', field.label);
          box.append(content); return;
        }
        content.append(root.querySelector('[data-trade-' + field.document + ']').content.cloneNode(true));
        content.firstElementChild.tabIndex = 0;
        content.firstElementChild.setAttribute('role', 'region');
        content.firstElementChild.setAttribute('aria-label', field.label);
        box.append(content);
        return;
      }
      if (field.type === 'note') { box.classList.add('trade-account__wide'); box.append(el('p', field.text)); return; }
      if (field.type === 'group') {
        box.classList.add('trade-account__group');
        box.append(el('legend', field.label, 'trade-account__section-heading'));
        const contactTarget = ['primary', 'accounts'].find(target => field.fields.some(child => child.name === target + 'FirstName'));
        if (contactTarget) {
          const label = el('label', '', 'trade-account__choice');
          const checkbox = el('input'); checkbox.type = 'checkbox';
          checkbox.name = contactTarget + 'UseApplicant';
          label.append(checkbox, el('span', 'Use my contact details'));
          box.append(label);
          contactCopies.set(contactTarget, checkbox);
          checkbox.addEventListener('change', changed);
        }
        renderFields(field.fields, scope, box, prefix);
        if (field.address) setupAddress(field.address, box, scope);
        return;
      }
      if (field.type === 'repeat') {
        box.classList.add('trade-account__wide');
        box.append(el('h3', field.label + ' details', 'trade-account__section-heading'));
        const rowsHost = el('div');
        const add = el('button', 'Add ' + field.label.toLowerCase(), 'button button--secondary');
        add.type = 'button';
        box.append(rowsHost, add);
        controls.set(key, add);
        if (!Array.isArray(scope[field.name])) scope[field.name] = [];
        function rows() {
          // Drop references to removed controls and conditions before rebuilding this repeater.
          for (let i = conditional.length - 1; i >= 0; i--) if (rowsHost.contains(conditional[i].box)) conditional.splice(i, 1);
          for (const [path] of controls) if (path.startsWith(key + '.')) controls.delete(path);
          rowsHost.replaceChildren();
          scope[field.name].forEach((row, index) => {
            const group = el('fieldset', '', 'trade-account__repeat-row');
            group.append(el('legend', field.label + ' ' + (index + 1), 'trade-account__section-heading'));
            rowsHost.append(group);
            renderFields(field.fields, row, group, key + '.' + index + '.');
            const remove = el('button', 'Remove ' + field.label.toLowerCase() + ' ' + (index + 1), 'button button--secondary');
            remove.type = 'button';
            remove.disabled = scope[field.name].length <= field.minRows;
            remove.onclick = () => { scope[field.name].splice(index, 1); rows(); changed(); add.focus(); };
            group.append(remove);
          });
          add.disabled = scope[field.name].length >= field.maxRows;
          sync();
        }
        add.onclick = () => {
          if (scope[field.name].length >= field.maxRows) return;
          scope[field.name].push({}); rows(); changed();
          rowsHost.lastElementChild.querySelector('input, select')?.focus();
        };
        rows(); return;
      }
      const id = root.getAttribute('aria-labelledby') + '-' + key.replaceAll('.', '-');
      function fieldLabel(tag) {
        const label = el(tag);
        const text = el('span', field.label);
        if (field.required) {
          const marker = el('span', ' *', 'trade-account__required');
          marker.setAttribute('aria-hidden', 'true');
          text.append(marker);
        }
        label.append(text);
        return label;
      }
      if (field.type === 'checks' && field.singleSelect) {
        box.classList.add('trade-account__wide','trade-account__field--control');
        const label=fieldLabel('label');label.htmlFor=id;box.append(label);
        const control=el('div','','trade-account__control');
        const input=el('select');input.id=id;input.name=key;
        if(field.required)input.setAttribute('aria-required','true');
        const blank=el('option','Please select');blank.value='';input.append(blank);
        field.options.forEach(value=>{const option=el('option',value);option.value=value;input.append(option)});
        input.value=Array.isArray(scope[field.name])&&scope[field.name].length===1?scope[field.name][0]:'';
        input.onchange=()=>{scope[field.name]=input.value?[input.value]:[];changed()};
        control.append(input);box.append(control);controls.set(key,input);
      } else if (field.type === 'checks') {
        box.append(fieldLabel('legend'));
        field.options.forEach((option, i) => {
          const label = el('label', '', 'trade-account__choice');
          const input = el('input'); input.type = 'checkbox'; input.id = id + '-' + i;
          input.checked = (scope[field.name] || []).includes(option);
          input.onchange = () => {
            const current = new Set(scope[field.name] || []);
            input.checked ? current.add(option) : current.delete(option);
            scope[field.name] = [...current]; changed();
          };
          label.append(input, document.createTextNode(option)); box.append(label);
          if (!i) controls.set(key, input);
        });
      } else {
        const input = el(field.type === 'select' ? 'select' : field.type === 'textarea' ? 'textarea' : 'input');
        input.id = id; input.name = key;
        if (input.tagName === 'INPUT') input.type = field.type;
        if (field.type === 'url') {
          input.type = 'text';
          input.setAttribute('inputmode', 'url');
          input.setAttribute('autocapitalize', 'off');
          input.setAttribute('spellcheck', 'false');
        }
        if (field.type === 'email') {
          input.setAttribute('autocapitalize', 'off');
          input.setAttribute('spellcheck', 'false');
          input.setAttribute('inputmode', 'email');
        }
        if (field.type === 'tel') input.setAttribute('inputmode', 'tel');
        if (field.type === 'select') {
          const blank = el('option', 'Please select'); blank.value = ''; input.append(blank);
          field.options.forEach(value => { const option = el('option', value); option.value = value; input.append(option); });
        }
        for (const attr of ['autocomplete','inputmode','min','max','step','maxlength','pattern']) if (field[attr] !== undefined) input.setAttribute(attr, field[attr]);
        if (field.required) input.setAttribute('aria-required', 'true');
        input.maxLength = field.type === 'textarea' ? 4000 : (field.maxlength || 300);
        if (field.name === 'yearStarted') {
          // Keep numeric validation, but use a plain year field without a spinbutton.
          input.type = 'text';
          input.setAttribute('inputmode', 'numeric');
          input.setAttribute('pattern', '[0-9]{4}');
          input.setAttribute('maxlength', '4');
          input.maxLength = 4;
          input.removeAttribute('min');
        }
        const label = fieldLabel('label'); label.htmlFor = id;
        if (field.type === 'checkbox') {
          box.classList.add('trade-account__wide'); label.className = 'trade-account__choice';
          input.checked = scope[field.name] === true;
          label.prepend(input); box.append(label);
        } else {
          box.classList.add('trade-account__field--control');
          const control = el('div', '', 'trade-account__control');
          input.value = scope[field.name] || ''; control.append(input); box.append(label, control);
        }
        if (field.type === 'textarea') box.classList.add('trade-account__wide');
        input.addEventListener(field.type === 'checkbox' || field.type === 'select' ? 'change' : 'input', () => {
          scope[field.name] = field.type === 'checkbox' ? input.checked : input.value;
          contactCopies.forEach((checkbox, target) => {
            if (contactParts.some(part => key === target + part)) checkbox.checked = false;
          });
          input.removeAttribute('aria-invalid');
          if (field.name === 'accuracyAccepted') { dirty = true; } else changed();
        });
        controls.set(key, input);
        if (key === 'authorisedEmails' || field.emailList) input.addEventListener('blur', formatEmailLists);
      }
      if (field.help) { const help = el('p', field.help, 'trade-account__hint'); help.id = id + '-help'; box.append(help); controls.get(key)?.setAttribute('aria-describedby', help.id); }
    });
  }
  async function api(path, payload) {
    const response = await fetch(endpoint + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: AbortSignal.timeout(25000), credentials: 'omit' });
    const body = await response.json();
    if (!response.ok) {
      const error = new Error(body.code || 'submission_failed');
      if (body.code === 'privacy_changed') error.privacy = body.privacy;
      if (body.code === 'terms_changed') error.terms = body.terms;
      throw error;
    }
    return body;
  }
  function setupAddress(prefix, box, scope) {
    const input = controls.get(prefix + 'Street');
    input.closest('.trade-account__field').classList.add('trade-account__wide');
    const notice = el('p', '', 'trade-account__hint');
    notice.setAttribute('aria-live', 'polite');
    input.after(notice);
    let selected = false, autocomplete, loading = false;
    input.addEventListener('input', () => {
      notice.textContent = '';
      if (selected) {
        selected = false;
        for (const part of ['Suburb', 'State', 'Postcode']) {
          scope[prefix + part] = ''; controls.get(prefix + part).value = '';
        }
      }
    });
    input.addEventListener('focus', async () => {
      if (autocomplete || loading || !root.dataset.googleMapsApiKey) return;
      loading = true;
      try {
        await loadAddressLibrary(root.dataset.googleMapsApiKey);
        if (!root.contains(input)) return;
        autocomplete = new window.google.maps.places.Autocomplete(input, {
          componentRestrictions: { country: 'au' }, fields: ['address_components']
        });
        autocomplete.addListener('place_changed', () => {
          const components = autocomplete.getPlace()?.address_components;
          if (!components) return; // Free-text addresses remain valid.
          const component = (type, short = false) => {
            const value = components.find(item => item.types.includes(type));
            return value?.[short ? 'short_name' : 'long_name'] || '';
          };
          const street = [component('street_number'), component('route')].filter(Boolean).join(' ');
          const unit = component('subpremise');
          const details = {
            Street: street ? (unit ? unit + '/' : '') + street : input.value,
            Suburb: component('locality') || component('postal_town') || component('sublocality') || component('sublocality_level_1'),
            State: component('administrative_area_level_1', true).toUpperCase(),
            Postcode: component('postal_code')
          };
          for (const part of ['Street', 'Suburb', 'State', 'Postcode']) {
            scope[prefix + part] = details[part];
            controls.get(prefix + part).value = details[part];
            // Update form state directly: synthetic typing reopens Google's suggestions.
            controls.get(prefix + part).removeAttribute('aria-invalid');
          }
          selected = true; changed();
          notice.textContent = '';
        });
      } catch { notice.textContent = 'Address suggestions are unavailable. Please enter the address manually.'; }
      finally { loading = false; }
    });
  }
  steps.forEach((step, index) => {
    const panel = el('section'); panel.hidden = index !== 0; panel.dataset.page = index;
    panel.setAttribute('aria-label', step.title);
    (step.intro || []).forEach(content => {
      if (Array.isArray(content)) {
        const list = el('ul');
        content.forEach(text => list.append(el('li', text)));
        panel.append(list);
      } else {
        panel.append(el('p', content));
      }
    });
    if (step.review) { const summary = el('div'); summary.dataset.review = ''; panel.append(summary); }
    renderFields(step.fields, values, panel);
    host.append(panel); panels.push(panel);
  });
  function review() {
    const summary = root.querySelector('[data-review]'); summary.replaceChildren();
    const cleaned = cleanValues(values);
    steps.forEach((step, index) => {
      if (!step.fields.length || step.review) return;
      const section = el('section', '', 'trade-account__review'); section.append(el('h3', step.title, 'trade-account__section-heading'));
      const edit = el('button', 'Edit ' + step.title, 'button button--secondary'); edit.type = 'button'; edit.onclick = () => show(index);
      const dl = el('dl');
      displayEntries(step.fields, cleaned).forEach(([label, value]) => dl.append(el('dt', label), el('dd', value)));
      section.append(edit, dl); summary.append(section);
    });
  }
  function show(index) {
    page = index; sync(); panels.forEach((panel, i) => { panel.hidden = i !== page; });
    back.hidden = page === 0; next.hidden = page === steps.length - 1; submit.hidden = !next.hidden;
    next.textContent = page === 0 ? 'Begin Application' : 'Continue';
    root.querySelector('[data-trade-progress]').textContent = 'Step ' + (page + 1) + ' of ' + steps.length + ' — ' + steps[page].title;
    root.querySelector('[data-trade-meter]').value = page + 1;
    if (steps[page].review) review();
    message(''); root.querySelector('[data-trade-progress]').focus();
  }
  function errorsForPage(index) {
    if (steps[index].fields.some(field => field.name === 'privacyAccepted') && !privacyValid()) return [{ name: 'privacyAccepted', message: 'The privacy notice is unavailable. Please reload this page.' }];
    if (steps[index].fields.some(field => field.name === 'termsAccepted') && !termsValid()) {
      return [{ name: 'termsAccepted', message: 'The terms are unavailable. Please try again later.' }];
    }
    return validateApplication(cleanValues(values)).filter(error => {
      const control = controls.get(error.name);
      return control && panels[index].contains(control);
    });
  }
  function presentErrors(errors) {
    controls.forEach(control => control.removeAttribute('aria-invalid'));
    errors.forEach(error => controls.get(error.name)?.setAttribute('aria-invalid', 'true'));
    message(errors[0].message, true); controls.get(errors[0].name)?.focus();
  }
  next.onclick = () => { formatEmailLists(); const errors = errorsForPage(page); errors.length ? presentErrors(errors) : show(page + 1); };
  back.onclick = () => show(page - 1);
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (sending || finished) return;
    if (page !== steps.length - 1) { next.click(); return; }
    const cleaned = cleanValues(values);
    const errors = validateApplication(cleaned);
    if (!privacyValid()) errors.unshift({ name: 'privacyAccepted', message: 'The privacy notice is unavailable. Please reload this page.' });
    if (!termsValid()) errors.unshift({ name: 'termsAccepted', message: 'The terms are unavailable. Please try again later.' });
    if (errors.length) {
      const index = panels.findIndex(panel => panel.contains(controls.get(errors[0].name)));
      show(Math.max(0, index)); presentErrors(errors); return;
    }
    if (!endpoint || !siteKey) { message('This application form is not accepting submissions yet. Please contact info@artisanchemist.com.au.', true); return; }
    const snapshot = JSON.stringify({ values: cleaned, termsHash: terms.hash, privacyHash: privacy.hash, privacyVersion: privacy.version });
    if (submittedSnapshot && submittedSnapshot !== snapshot) applicationId = crypto.randomUUID();
    submittedSnapshot = snapshot;
    sending = true; submit.disabled = true; back.disabled = true; form.inert = true; form.setAttribute('aria-busy', 'true');
    message('Submitting your application…');
    try {
      const recaptchaToken = await captcha(siteKey, 'trade_account_application');
      const result = await api('', { applicationId, termsVersion: terms.version, termsHash: terms.hash, privacyVersion: privacy.version, privacyHash: privacy.hash, values: cleaned, recaptchaToken, faxConfirmation: form.elements.faxConfirmation.value });
      if (result.status !== 'accepted' || result.applicationId !== applicationId) throw new Error('invalid_response');
      finished = true; dirty = false; window.removeEventListener('beforeunload', warn); form.hidden = true;
      const success = root.querySelector('[data-trade-success]'); success.hidden = false;
      const reference = /^TA-\d{5,16}$/.test(result.reference || '') ? result.reference : result.applicationId;
      root.querySelector('[data-trade-reference]').textContent = 'Application reference: ' + reference;
      success.focus();
    } catch (error) {
      if (error.message === 'privacy_changed' && error.privacy) {
        privacy = error.privacy; renderPrivacy();
        values.privacyAccepted = false; controls.get('privacyAccepted').checked = false;
        controls.get('privacyAccepted').disabled = !privacyValid();
        values.accuracyAccepted = false; controls.get('accuracyAccepted').checked = false;
        applicationId = crypto.randomUUID(); submittedSnapshot = undefined;
        show(steps.findIndex(step => step.fields.some(field => field.name === 'privacyAccepted')));
        message('The privacy notice has changed. Please read it and acknowledge it again. Your other answers have been kept.', true);
        return;
      }
      if (error.message === 'terms_changed' && error.terms) {
        terms = error.terms; renderTerms();
        values.termsAccepted = false; controls.get('termsAccepted').checked = false;
        controls.get('termsAccepted').disabled = !termsValid();
        values.accuracyAccepted = false; controls.get('accuracyAccepted').checked = false;
        applicationId = crypto.randomUUID(); submittedSnapshot = undefined;
        show(steps.findIndex(step => step.fields.some(field => field.name === 'termsAccepted')));
        message('The terms have changed. Please read the updated terms and agree again. Your other answers have been kept.', true);
        return;
      }
      message(error.message === 'captcha_failed'
        ? 'The security check could not be completed. Please try again, or contact info@artisanchemist.com.au.'
        : 'We could not confirm receipt. Your answers are still here; please retry. If this continues, contact info@artisanchemist.com.au and quote ' + applicationId + '.', true);
    } finally { sending = false; submit.disabled = false; back.disabled = false; form.inert = false; form.removeAttribute('aria-busy'); }
  });
  sync(); form.hidden = false;
  controls.get('privacyAccepted').disabled = !privacyValid();
  controls.get('termsAccepted').disabled = !termsValid();
  root.querySelector('[data-trade-progress]').textContent = 'Step 1 of ' + steps.length + ' — Introduction';
  back.hidden = true; next.textContent = 'Begin Application';
}
document.querySelectorAll('[data-trade-account]').forEach(initialise);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-trade-account]').forEach(initialise));
